import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../assets/diagram.png';
import _imports_1 from '../../assets/empty.png';
const _hoisted_1 = {
  class: "search_box"
};
const _hoisted_2 = {
  class: "search_input"
};
const _hoisted_3 = {
  key: 0,
  class: "result_box"
};
const _hoisted_4 = {
  key: 0,
  class: "no_result"
};
const _hoisted_5 = {
  key: 1,
  class: "result_list"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
import { ElMessage, ElLoading } from 'element-plus';
import { reactive } from 'vue';
import axios from 'axios';
import Request from '@/utils/request.js';
export default {
  __name: 'serialNo',
  setup(__props) {
    const info = reactive({
      inputVal: '',
      results: null
    });
    //实例化请求
    const request = new Request();
    //搜索
    const queryResults = () => {
      if (info.inputVal == '') {
        ElMessage({
          type: 'error',
          message: '请输入产品SN码!'
        });
        return false;
      }
      let serial_sn = info.inputVal;
      request.get('serialno/query', {
        sn: serial_sn
      }).then(res => {
        if (res.errno == 200) {
          info.results = res.data;
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg
          });
          info.results = [];
        }
      });
    };
    //回车查询
    const enterClick = () => {
      queryResults();
    };
    //清空搜索框
    const clearClick = () => {
      info.inputVal = '';
      info.results = [];
    };
    return (_ctx, _cache) => {
      const _component_search = _resolveComponent("search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
          class: "width_993"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 18,
            class: "search_left"
          }, {
            default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "search_left_title"
            }, "请输入产品SN码回车查询", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
              modelValue: info.inputVal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => info.inputVal = $event),
              onKeyup: [_cache[1] || (_cache[1] = $event => info.inputVal = info.inputVal.replace(/[\u4e00-\u9fff]/g, '')), _withKeys(enterClick, ["enter", "native"])],
              maxlength: "100",
              placeholder: "请输入产品SN码，例如：1037N2YBR6B"
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "el-input__icon",
                size: 24,
                color: "#BCBFC8"
              }, {
                default: _withCtx(() => [_createVNode(_component_search)]),
                _: 1
              })]),
              suffix: _withCtx(() => [info.inputVal.length > 0 ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "el-input__icon",
                size: 24,
                color: "#B8BABF",
                onClick: clearClick
              }, {
                default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              round: "",
              onClick: queryResults
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("搜索")])),
              _: 1,
              __: [2]
            })])]),
            _: 1,
            __: [3]
          }), _createVNode(_component_el_col, {
            span: 6,
            class: "search_right"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("img", {
              style: {
                "width": "218px",
                "height": "120px"
              },
              src: _imports_0
            }, null, -1)])),
            _: 1,
            __: [4]
          })]),
          _: 1
        })]), info.results != null ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_row, {
          class: "width_993"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24,
            class: "result_title"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("查询结果")])),
            _: 1,
            __: [5]
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [info.results.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [_createElementVNode("img", {
              style: {
                "width": "96px",
                "height": "96px"
              },
              src: _imports_1
            }, null, -1), _createElementVNode("p", null, "暂无数据", -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form, {
              "label-width": "205px",
              "label-position": "left"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SN码"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(info.results.sn), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "物料编码"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(info.results.fnumber), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "产品名称"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(info.results.name), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "规格型号（SKU）"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(info.results.sku), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "生产/采购订单号"
              }, {
                default: _withCtx(() => [info.results.porder_sn == '' || info.results.porder_sn == null ? (_openBlock(), _createElementBlock("span", _hoisted_6, "--")) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(info.results.porder_sn), 1))]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "生产时间"
              }, {
                default: _withCtx(() => [info.results.product_time == '' || info.results.product_time == null ? (_openBlock(), _createElementBlock("span", _hoisted_8, "--")) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(info.results.product_time), 1))]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "入库时间"
              }, {
                default: _withCtx(() => [info.results.warehouse_time == '' || info.results.warehouse_time == null ? (_openBlock(), _createElementBlock("span", _hoisted_10, "--")) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(info.results.warehouse_time), 1))]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "销售订单号"
              }, {
                default: _withCtx(() => [info.results.sale_order_sn == '' || info.results.sale_order_sn == null ? (_openBlock(), _createElementBlock("span", _hoisted_12, "--")) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(info.results.sale_order_sn), 1))]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "销售出库时间"
              }, {
                default: _withCtx(() => [info.results.sale_time == '' || info.results.sale_time == null ? (_openBlock(), _createElementBlock("span", _hoisted_14, "--")) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(info.results.sale_time), 1))]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "客户"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(info.results.custom), 1)]),
                _: 1
              })]),
              _: 1
            })]))]),
            _: 1
          })]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};